export default __webpack_public_path__ + "static/media/dashboard.8119791c.svg";